import { apiServer } from "../config/config";

export interface EmailCheckResult {
  data: {
    id: number;
    email: string;
    email_verification: number;
    first_name: string;
    last_name: string;
    profile_photo: string;
  } | null;
  status: string;
  message: string;
  registerEmail?: string;
  social_status?:string;
}

export async function checkEmail(email: string): Promise<EmailCheckResult> {
  const emailData = { email };
  const response = await fetch(apiServer + "/user/check-email-exist", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify(emailData),
  });

  if (!response.ok) {
    throw new Error(`Failed to check email: ${response.status}`);
  }

  const responseData = await response.json();
  return responseData;
}
